module.exports = __webpack_public_path__ + "dcf0bc4b708aad645dbb08127e4d60d7.svg";